import { createFileRoute, useNavigate } from '@tanstack/react-router';
// Route options read the light search module; the viewer (and pdf.js) loads with the component.
import { ViewerPage } from '@/features/documents/viewer';
import { ViewerSearchSchema } from '@/features/documents/viewer/search';

/** A document of a project, opened in the viewer; `?versionId=` names the version shown, `?compare=` a second one to compare it with. */
export const Route = createFileRoute('/_auth/o/$orgId/projects/$projectId/documents/$documentId')({
  validateSearch: (search) => ViewerSearchSchema.parse(search),
  component: ViewerRoute,
});

function ViewerRoute() {
  const { orgId, projectId, documentId } = Route.useParams();
  const { versionId, compare, page } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <ViewerPage
      orgId={orgId}
      projectId={projectId}
      documentId={documentId}
      versionId={versionId}
      compareVersionId={compare}
      initialPage={page}
      onCompareChange={(next, other) => {
        void navigate({
          to: '/o/$orgId/projects/$projectId/documents/$documentId',
          params: { orgId, projectId, documentId },
          search: other ? { versionId: next, compare: other } : { versionId: next },
          replace: true,
        });
      }}
      onVersionChange={(next) => {
        void navigate({
          to: '/o/$orgId/projects/$projectId/documents/$documentId',
          params: { orgId, projectId, documentId },
          search: { versionId: next },
          replace: true,
        });
      }}
      onBack={() => {
        void navigate({
          to: '/o/$orgId/projects/$projectId/$tab',
          params: { orgId, projectId, tab: 'files' },
        });
      }}
    />
  );
}
